import { ShippingMethod } from '~/lib/data-contract/salesforce';
import { DeliveryMethod, DeliveryTypes } from '../models/checkout';

export const getDeliveryMethods = (carrier: ShippingMethod): DeliveryMethod | undefined => {
    switch (carrier.c_shippingType) {
        case DeliveryTypes.truck: {
            return 'truckDelivery';
        }
        case DeliveryTypes.addressDelivery: {
            return 'addressDelivery';
        }
        case DeliveryTypes.dropPoint: {
            return 'dropPoint';
        }
        case DeliveryTypes.clickAndCollect: {
            return 'clickAndCollect';
        }
        case DeliveryTypes.virtual: {
            return 'virtual';
        }
        default: {
            return undefined;
        }
    }
};
